import { LlmModelId, LlmModelOption } from '@/types/llmModels.ts';

export const AUTOMATION_DEFAULT_MODEL_OPTION_VALUE = '__automation_default__';

export const formatModelLabel = (
  model: LlmModelOption | undefined,
  modelId: LlmModelId,
): string => {
  const label = model?.display_name ?? modelId;
  return model?.deprecated ? `${label} (deprecated)` : label;
};

type BuildModelSelectOptionsParams = {
  modelIds: LlmModelId[];
  modelById: Map<LlmModelId, LlmModelOption>;
  currentModelId?: LlmModelId | null;
  includeAutomationDefault?: boolean;
};

export const buildModelSelectOptions = ({
  modelIds,
  modelById,
  currentModelId,
  includeAutomationDefault = false,
}: BuildModelSelectOptionsParams) => {
  const optionIds =
    currentModelId && !modelIds.includes(currentModelId) ? [currentModelId, ...modelIds] : modelIds;

  const modelOptions = optionIds.map((modelId) => ({
    value: modelId,
    label: formatModelLabel(modelById.get(modelId), modelId),
  }));

  if (!includeAutomationDefault) {
    return modelOptions;
  }

  return [{ value: AUTOMATION_DEFAULT_MODEL_OPTION_VALUE, label: 'Automation default' }, ...modelOptions];
};
